module.exports = __webpack_public_path__ + "static/media/norway.7a69b4d9.png";